import React, { useState } from "react";
import { styles, theme } from "./theme";

interface ChartWidgetProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  onExpand?: () => void;
  headerAction?: React.ReactNode;
}

// Modern expand icon
const ExpandIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15 3 21 3 21 9" />
    <polyline points="9 21 3 21 3 15" />
    <line x1="21" y1="3" x2="14" y2="10" />
    <line x1="3" y1="21" x2="10" y2="14" />
  </svg>
);

const ChartWidget: React.FC<ChartWidgetProps> = ({ title, subtitle, children, onExpand, headerAction }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div style={styles.chartWidget as React.CSSProperties}>
      <div style={{ ...(styles.chartWidgetHeader as React.CSSProperties), alignItems: 'flex-start', marginBottom: '20px' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#1e293b" }}>{title}</h3>
          {subtitle && (
            <p style={{ margin: "4px 0 0", fontSize: "13px", color: "#64748b", fontWeight: 400 }}>{subtitle}</p>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
          {headerAction}
          {onExpand && (
          <button
            onClick={onExpand}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            title="View Fullscreen"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "8px 14px",
              borderRadius: "20px",
              border: "none",
              background: isHovered
                ? "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)"
                : "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
              color: isHovered ? "#ffffff" : "#64748b",
              fontSize: "12px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s ease",
              boxShadow: isHovered
                ? "0 4px 12px rgba(99, 102, 241, 0.3)"
                : "0 1px 3px rgba(0, 0, 0, 0.08)",
              transform: isHovered ? "translateY(-1px)" : "translateY(0)",
            }}
          >
            <ExpandIcon />
            <span>Expand</span>
          </button>
        )}
        </div>
      </div>
      <div style={styles.chartWidgetContent as React.CSSProperties}>{children}</div>
    </div>
  );
};

export default ChartWidget;
